import React, { lazy, Suspense } from 'react';
import { HashRouter, Route, Switch } from 'react-router-dom';

import Loading from './loading';
import Wrapper from './Wrapper';
import Error404 from './Components/404';

const Login = lazy(() => import('./../components/Login'));
const SystemDashboard = lazy(() => import('./../components/SystemDashboard'));
const MaintHist = lazy(() => import('./../components/MaintenanceHistory'));
const SmartEquip = lazy(() => import('./../components/SmartEquip'));
const WODashboard = lazy(() => import('./../components/WorkOrders/Dashboard'));
const WorkOrder = lazy(() => import('./../components/WorkOrders/WorkOrder'));
const KanbanBoard = lazy(() => import('./../components/Kanban/Board'));
const XMLPage = lazy(() => import('./../components/XML'));
const CountSheets = lazy(() => import ('./../components/CycleCounts/CountSheets'));
const CycleCountsCalendar = lazy(() => import('./../components/CycleCounts/Calendar'));

const Routes = () => {    
    let routes = [
        { route: `/`, component: Login, exact: true },
        { route: `/dashboard`, component: SystemDashboard, exact: true },
        { route: `/mainthist`, component: MaintHist, exact: true},
        { route: `/smartequip/:route`, component: SmartEquip, exact: true},
        { route: `/wo/dashboard`, component: WODashboard, exact: true },
        { route: `/wo/work_order/:id`, component: WorkOrder, exact: true},
        { route: `/insight`, component: KanbanBoard, exact: true},
        { route: `/xml/:id`, component: XMLPage, exact: true},
        { route: `/cycle_counts/count_sheets`, component: CountSheets, exact: true},
        { route: `/cycle_counts/calendar`, component: CycleCountsCalendar, exact: true},
    ];

    return (
        <HashRouter>
            <Suspense fallback={<Loading />}>
                <Wrapper>
                    <Switch>
                        {
                            routes.map((route,index) => {
                                return <Route key={index} exact={route.exact} path={route.route} component={route.component} />
                            })
                        }
                        <Route exact path="*" component={Error404} />
                    </Switch>
                </Wrapper>
            </Suspense>
        </HashRouter>
    )
}

export default Routes;